module.exports = __webpack_public_path__ + "static/4iiii4-3f8e9b3e681725e8fa3f623813b960f2.jpg";